/* eslint-disable */
// Clasificación heurística de motivos de incidente para el drawer KPI.
// Primera iteración — se ajusta con feedback operativo post-rollout.
// Ver KPI-DRAWER-REDISEÑO §8.3.

// Patrones que hacen que un motivo se considere "crítico". Se aplica con
// `motivo.includes(pattern)` case-insensitive (ambos en uppercase).
export const CRITICAL_PATTERNS = [
  'VIOLENCIA',
  'AGRESIV',
  'ARMA',
  'LESIONAD',
  'MALTRATO',
  'ABUSO',
  'ROBO A TRANSEUNTE',
  'ROBO DE VEHI',   // "VEHÍCULO" con o sin acento
  'ROBO DE VEHICULO',
  'HOMICIDIO',
  'DISPARO',
  'CADAVER',
  'CADÁVER',
  'CONVULSIONES',
  'INFARTO',
  'PERSONA INCONSCIENTE',
  'RAPTO',
  'DESAPARECID',
  'PRIVACION',
  'PRIVACIÓN',
]

// Motivos que aunque contengan alguna palabra clave deben NUNCA ser
// considerados críticos. Se aplica por igualdad exacta case-insensitive
// sobre el motivo completo.
export const EXCLUDED_FROM_CRITICAL = new Set([
  'LLAMADA MUDA',
  'LLAMADAS COLGADAS',
  'OTRAS ALARMAS DE EMERGENCIAS ACTIVADAS',
  'OTRAS ALARMAS',
  'SEGUIMIENTO',
  'VEHICULO DESCOMPUESTO',
  'VEHÍCULO DESCOMPUESTO',
  'VEHICULO ABANDONADO',
  'VEHÍCULO ABANDONADO',
  'OLORES',
  'RESCATE ANIMAL',
  'ANIMAL PELIGROSO',
])

// Devuelve true si el motivo cuenta como "crítico" según la heurística.
// Un motivo sin valor (null/undefined/"") devuelve false.
export function isCriticalMotivo(motivo) {
  if (!motivo) return false
  var upper = String(motivo).toUpperCase().trim()
  if (EXCLUDED_FROM_CRITICAL.has(upper)) return false
  for (var i = 0; i < CRITICAL_PATTERNS.length; i++) {
    if (upper.indexOf(CRITICAL_PATTERNS[i]) !== -1) return true
  }
  return false
}
